import React from 'react'
import LocalShipping from 'material-ui-icons/LocalShipping'
import PinDrop from 'material-ui-icons/PinDrop'
import DoneAll from 'material-ui-icons/DoneAll'
import Doughnut from 'material-ui-icons/FiberManualRecord'
import colors from '../helpers/colors'
import { withStyles } from 'material-ui/styles'
import Tooltip from 'material-ui/Tooltip'

const getStatusIcons = ({status, classes}) => {
  const onTheWay = <LocalShipping className={classes.statusColorStarted} />
  const checkedIn = <PinDrop className={classes.statusColorStarted} />
  const done = <DoneAll className={classes.statusColorDone} />

  let view

  switch (status) {
    case 'onTheWay':
      view = onTheWay
      break
    case 'checkedIn':
      view = checkedIn
      break
    case 'done':
      view = done
      break
    default:
      view = <Doughnut className={classes.statusColorNotDone} />
      break
  }

  if (!status) {
    return view
  }

  return <Tooltip title={status} placement='top'>{view}</Tooltip>
}

export default withStyles({
  ...colors
})(getStatusIcons)



// WEBPACK FOOTER //
// ./src/jobs/StatusIcon.js